import React from 'react'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { Chip, Grid, Typography } from '@mui/material'
import { usedUrl } from 'conf/basepath'
import { brutRgbMainBlue, mainBlue } from 'utils/constants/ColorTheme'
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded'

const ShowDataTypesRules = ({
    link,
    isGlobal = false,
}) => !!link && (
    <Grid container justifyContent='space-between' alignItems='center' columnSpacing={1}>
        <Grid size={0.5} />
        <Grid size='grow'>
            <Typography variant='normalFormTitle'>{i18n.additionelDataToDisplay}</Typography>
        </Grid>
        <Grid size={3.25}>
            <Chip
                label={i18n.setAdditionalData}
                icon={<ArrowOutwardRoundedIcon />}
                onClick={() => window.open(`${usedUrl}#/${link}`, '_blank').focus()}
                clickable
                variant='new-filled'
                sx={{
                    color: mainBlue,
                    backgroundColor: `rgba(${brutRgbMainBlue}, 0.06)`,
                    backgroundColorHover: `rgba(${brutRgbMainBlue}, 0.16)`,
                }}
            />
        </Grid>
        <Grid offset={!isGlobal && 3.25} size={0.5} />
    </Grid>
)

ShowDataTypesRules.propTypes = {
    link: PropTypes.string,
    isGlobal: PropTypes.bool,
}

export default ShowDataTypesRules
